/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import BusinessHeader from "../BusinessHeader";
import SidebarAdmin from "../SidebarAdmin";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { DatePicker } from "antd";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { usePermission } from "../../PermissionContext";

// Inline styles
const dropzoneStyles = {
  border: "2px dashed #d3d3d3",
  borderRadius: "5px",
  padding: "20px",
  textAlign: "center",
  backgroundColor: "#f9f9f9",
  cursor: "pointer",
  marginBottom: "1rem",
};

const dropzoneHoverStyles = {
  border: "2px dashed #a3a3a3",
  backgroundColor: "#e9e9e9",
};

const selectButtonStyles = {
  backgroundColor: "#7b1fa2",
  color: "white",
  padding: "8px 16px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  marginTop: "10px",
};

const takePhotoLinkStyles = {
  cursor: "pointer",
  color: "#5e6b7a",
  textDecoration: "underline",
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
};

const removePhotoLinkStyles = {
  cursor: "pointer",
  color: "#dc3545",
  textDecoration: "underline",
  marginLeft: "10px",
};

const imagePreviewStyles = {
  width: "150px",
  height: "150px",
  borderRadius: "50%",
  objectFit: "cover",
  marginBottom: "1rem",
  border: "2px solid #d3d3d3",
};

const AddDoctor = () => {
  const navigate = useNavigate();
  const { permissions } = usePermission();
  const hasPermission = permissions?.add_doctor === 1;

  const [formData, setFormData] = useState({
    user_id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    degree: "",
    aadhaar: "",
    pan: "",
    department: [],
    joiningDate: "",
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [digitCount, setDigitCount] = useState(0);
  const [requiredDigits, setRequiredDigits] = useState(10);
  const [departments, setDepartments] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [hasImage, setHasImage] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [errors, setErrors] = useState({});
  const [showAddDepartment, setShowAddDepartment] = useState(false);
  const [addFormData, setAddFormData] = useState({
    departmentName: "",
    parentDepartment: "",
  });
  const [userDetails, setUserDetails] = useState(null);
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const aadhaarRegex = /^\d{12}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Debugging permissions
  useEffect(() => {
    console.log("Permissions in AddDoctor:", permissions);
    console.log("Type of permissions:", typeof permissions);
    console.log("Is permissions an array?", Array.isArray(permissions));
    console.log("Has add_doctor?", permissions?.add_doctor === 1);
  }, [permissions]);

  // Fetch departments
  const fetchDepartments = () => {
    const businessId = localStorage.getItem("BusinessID");
    if (!businessId) {
      console.error("Business ID is missing.");
      toast.error("Business ID is missing.");
      return;
    }
    console.log("Fetching departments for businessID:", businessId);
    fetch(`${config.API_URL}get_departments.php?business_id=${businessId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setDepartments(data.data || data);
          console.log("Departments fetched successfully:", data.data || data);
        } else {
          console.error("Failed to fetch departments:", data.message);
          toast.error(data.message || "Failed to fetch departments.");
        }
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
        toast.error("Error fetching departments.");
      });
  };

  // Fetch user details by phone
  const fetchUserDetails = async (phone) => {
    if (!phone.trim()) {
      setUserDetails(null);
      setFormData({
        user_id: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        degree: "",
        aadhaar: "",
        pan: "",
        department: [],
        joiningDate: "",
      });
      setProfileImage(null);
      setHasImage(false);
      return;
    }

    try {
      const response = await fetch(`${config.API_URL}get_patient_profile.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });
      const data = await response.json();
      if (data.user_exists) {
        setUserDetails(data);
        setFormData((prev) => ({
          ...prev,
          user_id: data.user_id || "",
          firstName: data.first_name || "",
          lastName: data.last_name || "",
          email: data.email || "",
          phone: data.phone || phone,
        }));
        if (data.profile_image) {
          const imageUrl = data.profile_image.startsWith("http")
            ? data.profile_image
            : `${config.API_URL}uploads/profile_images/user_images/${data.profile_image}`;
          setProfileImage(imageUrl);
          setHasImage(true);
        } else {
          setProfileImage(null);
          setHasImage(false);
        }
      } else {
        setUserDetails(null);
        setFormData((prev) => ({
          ...prev,
          user_id: "",
          firstName: "",
          lastName: "",
          email: "",
          phone,
        }));
        setProfileImage(null);
        setHasImage(false);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      toast.error("Failed to fetch user details.");
      setUserDetails(null);
      setProfileImage(null);
      setHasImage(false);
    }
  };

  useEffect(() => {
    if (hasPermission) {
      fetchDepartments();
    } else {
      console.log("No permission to fetch departments");
      // toast.error("You do not have permission to add doctors.");
      // navigate("/dashboard");
    }
  }, [hasPermission, navigate]);

  // Phone validation
  const validatePhoneNumber = (phone, countryCode) => {
    const phoneLength = phone.length;
    switch (countryCode) {
      case "in":
      case "uk":
      case "us":
        return phoneLength === 10;
      case "ae":
      case "lk":
        return phoneLength === 9;
      case "ng":
      case "bd":
        return phoneLength === 10;
      default:
        return false;
    }
  };

  const getRequiredDigits = (countryCode) => {
    switch (countryCode) {
      case "in":
      case "gb":
      case "us":
      case "bd":
      case "ng":
        return 10;
      case "ae":
      case "lk":
        return 9;
      default:
        return 10;
    }
  };

  const handlePhoneNumberChange = (value, country) => {
    setPhoneNumber(value);
    const formattedPhone = value.replace(/\D/g, "");
    const digits = value.replace(country.dialCode, "");
    setDigitCount(digits.length);
    const digitsRequired = getRequiredDigits(country.countryCode);
    setRequiredDigits(digitsRequired);
    const isValid = validatePhoneNumber(digits, country.countryCode);
    if (!isValid) {
      setPhoneError(`Invalid phone number length for ${country.name}`);
      setIsPhoneNumberValid(false);
    } else {
      setPhoneError("");
      setIsPhoneNumberValid(true);
      const fullPhone = "+" + formattedPhone;
      setFormData((prev) => ({ ...prev, phone: fullPhone }));
      fetchUserDetails(fullPhone);
    }
  };

  // Input handling
  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "aadhaar") {
      formattedValue = value.replace(/\D/g, "").slice(0, 12);
    } else if (name === "pan") {
      formattedValue = value.toUpperCase().slice(0, 10);
    } else if (name === "firstName" || name === "lastName") {
      formattedValue = value
        .split(/(\s+|\()/g)
        .map((part, index, arr) =>
          part.length > 0
            ? part === "(" && index < arr.length - 1
              ? "("
              : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
            : part
        )
        .join("");
    }
    setFormData({ ...formData, [name]: formattedValue });
  };

  const handleDateChange = (date, dateString) => {
    setFormData({ ...formData, joiningDate: dateString });
  };

  // Department handling
  const handleDepartmentChange = (deptId) => {
    setFormData((prev) => {
      const updatedDepartments = prev.department.includes(deptId)
        ? prev.department.filter((id) => id !== deptId)
        : [...prev.department, deptId];
      return { ...prev, department: updatedDepartments };
    });
  };

  const renderDepartmentOptions = (departments, level = 0) => {
    return departments.map((dept) => (
      <div key={dept.id} className="form-check">
        <input
          type="checkbox"
          id={`dept-${dept.id}`}
          checked={formData.department.includes(dept.id)}
          onChange={() => handleDepartmentChange(dept.id)}
          className="form-check-input"
          disabled={!isPhoneNumberValid}
        />
        <label htmlFor={`dept-${dept.id}`} className="form-check-label ms-2">
          {`${"—".repeat(level)} ${dept.department_name}`}
        </label>
        {dept.children?.length > 0 && renderDepartmentOptions(dept.children, level + 1)}
      </div>
    ));
  };

  const renderDepartmentSelectOptions = (departments, level = 0) => {
    return departments.map((dept) => (
      <React.Fragment key={dept.id}>
        <option value={dept.id}>{`${"—".repeat(level)} ${dept.department_name}`}</option>
        {dept.children?.length > 0 && renderDepartmentSelectOptions(dept.children, level + 1)}
      </React.Fragment>
    ));
  };

  // Profile image handling
  const handleDragOver = (e) => {
    e.preventDefault();
    if (isPhoneNumberValid) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (!isPhoneNumberValid) return;
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type.startsWith("image/")) {
        setProfileImage(file);
        setHasImage(true);
      } else {
        toast.error("Please upload an image file.");
      }
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setProfileImage(file);
      setHasImage(true);
    } else {
      toast.error("Please upload an image file.");
    }
  };

  const handleOpenCamera = async (e) => {
    e.preventDefault();
    if (!isPhoneNumberValid) return;
    setIsCameraOn(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) videoRef.current.srcObject = stream;
    } catch (error) {
      console.error("Error accessing camera:", error);
      toast.error("Failed to access camera. Ensure camera permissions are granted.");
      setIsCameraOn(false);
    }
  };

  const handleCapturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((blob) => {
      if (!blob) return;
      const file = new File([blob], `profile_${Date.now()}.png`, { type: "image/png" });
      setProfileImage(file);
      setHasImage(true);
      stopCamera();
    }, "image/png");
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setIsCameraOn(false);
  };

  const handleRemovePhoto = (e) => {
    e.preventDefault();
    if (!isPhoneNumberValid) return;
    setProfileImage(null);
    setHasImage(false);
  };

  // Validation
  const validate = () => {
    let newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email)) newErrors.email = "Invalid email format";
    if (!formData.degree) newErrors.degree = "Degree/Education is required";
    if (!isPhoneNumberValid) newErrors.phone = "Valid phone number is required";
    if (formData.aadhaar && !aadhaarRegex.test(formData.aadhaar)) {
      newErrors.aadhaar = "Aadhaar must be 12 digits";
    }
    if (formData.pan && !panRegex.test(formData.pan.toUpperCase())) {
      newErrors.pan = "Invalid PAN format (e.g., ABCDE1234F)";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Add department
  const handleAddFormChange = (e) => {
    setAddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleDepartmentSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission) {
      console.warn("User lacks permission to add departments");
      toast.error("You do not have permission to add departments.");
      return;
    }
    const businessId = localStorage.getItem("BusinessID");
    if (!businessId) {
      toast.error("Business ID is missing.");
      return;
    }
    const departmentData = {
      business_id: businessId,
      department_name: addFormData.departmentName,
      parent_id: addFormData.parentDepartment || null,
    };
    console.log("Submitting new department:", departmentData);
    try {
      const response = await fetch(`${config.API_URL}add_department.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(departmentData),
      });
      const result = await response.json();
      console.log("Add department response:", result);
      if (result.status === "success") {
        toast.success("Department added successfully!");
        setAddFormData({ departmentName: "", parentDepartment: "" });
        setShowAddDepartment(false);
        fetchDepartments();
      } else {
        toast.error(result.message || "Failed to add department.");
      }
    } catch (error) {
      console.error("Error adding department:", error);
      toast.error("Failed to add department.");
    }
  };

  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission) {
      console.warn("User lacks permission to add doctors");
      toast.error("You do not have permission to add doctors.");
      return;
    }
    if (!validate()) {
      toast.error("Please fix form errors.");
      return;
    }
    const businessId = localStorage.getItem("BusinessID");
    const createdBy = localStorage.getItem("userUUID");
    if (!businessId || !createdBy) {
      toast.error("Missing Business ID or User ID.");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("business_id", businessId);
    formDataToSend.append("user_id", formData.user_id);
    formDataToSend.append("first_name", formData.firstName);
    formDataToSend.append("last_name", formData.lastName);
    formDataToSend.append("education", formData.degree);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("adhar_number", formData.aadhaar);
    formDataToSend.append("pan_number", formData.pan);
    formDataToSend.append("department", JSON.stringify(formData.department));
    formDataToSend.append("joining_date", formData.joiningDate || "");
    formDataToSend.append("created_by", createdBy);
    if (profileImage && profileImage instanceof File) {
      formDataToSend.append("profile_image", profileImage);
    }

    console.log("Submitting doctor data to:", `${config.API_URL}add_doctor.php`);
    try {
      const response = await fetch(`${config.API_URL}add_doctor.php`, {
        method: "POST",
        body: formDataToSend,
      });
      const result = await response.json();
      console.log("Add doctor response:", result);
      if (result.status === "success") {
        toast.success("Doctor added successfully!");
        setFormData({
          user_id: "",
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          degree: "",
          aadhaar: "",
          pan: "",
          department: [],
          joiningDate: "",
        });
        setPhoneNumber("");
        setProfileImage(null);
        setHasImage(false);
        setUserDetails(null);
        navigate("/doctorlist");
      } else {
        toast.error(result.message || "Failed to add doctor.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to add doctor.");
    }
  };

  // Lock fields if user exists
  const isFieldLocked = (fieldName) => {
    return userDetails && ["firstName", "lastName", "email"].includes(fieldName);
  };

  if (!hasPermission) {
    return (
      <div>
        <BusinessHeader />
        <SidebarAdmin id="menu-item1" id1="menu-items1" activeClassName="add-doctor" />
        <div className="page-wrapper">
          <div className="content">
            <div className="alert alert-fill alert-danger alert-icon">
              <FeatherIcon icon="cross-circle" />
              <strong>Access Denied</strong>! You do not have permission to add doctors.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      <BusinessHeader />
      <SidebarAdmin id="menu-item1" id1="menu-items1" activeClassName="add-doctor" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/doctorlist">Doctors</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Add Doctor</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Doctor Details</h4>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Phone Number <span className="login-danger">*</span>
                          </label>
                          <PhoneInput
                            onlyCountries={["in", "gb", "us", "ae", "ng", "lk", "bd"]}
                            country={"in"}
                            value={phoneNumber}
                            onChange={handlePhoneNumberChange}
                            className="phoneinput"
                            placeholder="Enter phone number"
                            countryCodeEditable={false}
                            masks={{
                              in: "..........",
                              gb: "..........",
                              us: "..........",
                              ae: ".........",
                              ng: "..........",
                              lk: ".........",
                              bd: "..........",
                            }}
                          />
                          <div className="mt-2 d-flex justify-content-between">
                            {phoneError && <div className="text-danger">{phoneError}</div>}
                            <div>{digitCount}/{requiredDigits}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            First Name <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            onKeyPress={(e) => {
                              if (!/[A-Za-z]/.test(e.key)) e.preventDefault();
                            }}
                            placeholder="Enter first name"
                            disabled={!isPhoneNumberValid || isFieldLocked("firstName")}
                            readOnly={isFieldLocked("firstName")}
                          />
                          {errors.firstName && (
                            <div className="invalid-feedback">{errors.firstName}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Last Name <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            onKeyPress={(e) => {
                              if (!/[A-Za-z]/.test(e.key)) e.preventDefault();
                            }}
                            placeholder="Enter last name"
                            disabled={!isPhoneNumberValid || isFieldLocked("lastName")}
                            readOnly={isFieldLocked("lastName")}
                          />
                          {errors.lastName && (
                            <div className="invalid-feedback">{errors.lastName}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Email <span className="login-danger">*</span>
                          </label>
                          <input
                            type="email"
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter email"
                            disabled={!isPhoneNumberValid || isFieldLocked("email")}
                            readOnly={isFieldLocked("email")}
                          />
                          {errors.email && (
                            <div className="invalid-feedback">{errors.email}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Degree/Education <span className="login-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.degree ? "is-invalid" : ""}`}
                            name="degree"
                            value={formData.degree}
                            onChange={handleChange}
                            placeholder="Enter degree"
                            disabled={!isPhoneNumberValid}
                          />
                          {errors.degree && (
                            <div className="invalid-feedback">{errors.degree}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms cal-icon">
                          <label>Joining Date</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            onChange={handleDateChange}
                            suffixIcon={null}
                            disabled={!isPhoneNumberValid}
                            format="YYYY-MM-DD"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>Aadhaar (Optional)</label>
                          <input
                            type="text"
                            className={`form-control ${errors.aadhaar ? "is-invalid" : ""}`}
                            name="aadhaar"
                            value={formData.aadhaar}
                            onChange={handleChange}
                            placeholder="Enter Aadhaar number"
                            disabled={!isPhoneNumberValid}
                          />
                          {errors.aadhaar && (
                            <div className="invalid-feedback">{errors.aadhaar}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>PAN (Optional)</label>
                          <input
                            type="text"
                            className={`form-control ${errors.pan ? "is-invalid" : ""}`}
                            name="pan"
                            value={formData.pan}
                            onChange={handleChange}
                            placeholder="Enter PAN number"
                            disabled={!isPhoneNumberValid}
                          />
                          {errors.pan && <div className="invalid-feedback">{errors.pan}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-4">
                        <div className="form-group local-forms">
                          <label>Department (Optional)</label>
                          <div
                            className="border p-2 rounded"
                            style={{ maxHeight: "150px", overflowY: "auto" }}
                          >
                            {departments.length > 0 ? (
                              renderDepartmentOptions(departments)
                            ) : (
                              <p className="text-muted">No departments available.</p>
                            )}
                          </div>
                          <a
                            href="#"
                            className="text-primary mt-2 d-block"
                            onClick={(e) => {
                              e.preventDefault();
                              if (isPhoneNumberValid) setShowAddDepartment(!showAddDepartment);
                            }}
                          >
                            + Add Department
                          </a>
                        </div>
                      </div>
                      <div className="col-12 col-md-8 col-xl-8">
                        <div className="form-group local-forms">
                          <label>Profile Image (Optional)</label>
                          {!isCameraOn && !hasImage ? (
                            <div
                              style={{
                                ...dropzoneStyles,
                                ...(isDragging ? dropzoneHoverStyles : {}),
                                ...(!isPhoneNumberValid ? { pointerEvents: "none", opacity: 0.6 } : {}),
                              }}
                              onDragOver={handleDragOver}
                              onDragLeave={handleDragLeave}
                              onDrop={handleDrop}
                              onClick={() => isPhoneNumberValid && fileInputRef.current.click()}
                            >
                              <p>
                                {profileImage ? `Selected: ${profileImage.name || "Image"}` : "Drag and drop image"}
                              </p>
                              {!profileImage && (
                                <>
                                  <p>OR</p>
                                  <button style={selectButtonStyles} type="button" disabled={!isPhoneNumberValid}>
                                    SELECT
                                  </button>
                                </>
                              )}
                            </div>
                          ) : isCameraOn ? (
                            <div>
                              <video
                                ref={videoRef}
                                autoPlay
                                style={{ width: "100%", maxHeight: "200px" }}
                              ></video>
                              <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
                              <div className="mt-2">
                                <button
                                  type="button"
                                  className="btn btn-primary me-2"
                                  onClick={handleCapturePhoto}
                                  disabled={!isPhoneNumberValid}
                                >
                                  Capture
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={stopCamera}
                                  disabled={!isPhoneNumberValid}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="text-center">
                              <img
                                src={
                                  profileImage instanceof File
                                    ? URL.createObjectURL(profileImage)
                                    : profileImage
                                }
                                alt="Profile Preview"
                                style={imagePreviewStyles}
                              />
                            </div>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            ref={fileInputRef}
                            onChange={handleFileSelect}
                            disabled={!isPhoneNumberValid}
                          />
                          <div className="d-flex justify-content-between">
                            <a
                              href="#"
                              style={takePhotoLinkStyles}
                              onClick={handleOpenCamera}
                              className={!isPhoneNumberValid ? "disabled" : ""}
                            >
                              <FeatherIcon icon="camera" />
                              Take a Photo
                            </a>
                            {hasImage && (
                              <a
                                href="#"
                                style={removePhotoLinkStyles}
                                onClick={handleRemovePhoto}
                                className={!isPhoneNumberValid ? "disabled" : ""}
                              >
                                Remove Photo
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                      {showAddDepartment && (
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Add New Department</label>
                            <div className="border p-3 rounded bg-light">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="departmentName"
                                  value={addFormData.departmentName}
                                  onChange={handleAddFormChange}
                                  placeholder="Department Name"
                                  disabled={!isPhoneNumberValid}
                                />
                              </div>
                              <div className="form-group mt-2">
                                <select
                                  name="parentDepartment"
                                  className="form-control"
                                  value={addFormData.parentDepartment}
                                  onChange={handleAddFormChange}
                                  disabled={!isPhoneNumberValid}
                                >
                                  <option value="">Select Parent Department</option>
                                  {renderDepartmentSelectOptions(departments)}
                                </select>
                              </div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={handleDepartmentSubmit}
                                disabled={!isPhoneNumberValid || !addFormData.departmentName}
                              >
                                Create Department
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                            disabled={
                              !isPhoneNumberValid ||
                              !formData.firstName ||
                              !formData.lastName ||
                              !formData.email ||
                              !formData.degree
                            }
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary cancel-form"
                            onClick={() => navigate("/doctors")}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDoctor;